document.addEventListener('DOMContentLoaded', () => {
    var Gd88controller = new ScrollMagic.Controller();
    var t2 = new TimelineMax();
    t2.add([
        TweenLite.to('.zero-one', 1, { className: '+=trans-Bg-one-left' }),
        TweenLite.to('.Bg-one-left', 0.5, { className: '+=trans-Bg-one-left', delay: 1 }),
        TweenLite.to('.blue-wave', 0.5, { css: { display: 'none' } }),
        TweenLite.to('.grenn-wave', 0.5, { css: { display: 'none' } }),
    ]).add([
        TweenLite.to('.Bgtwo-container', 2, { css: { opacity: 1 }, ease: Linear.ease }),
        TweenLite.to('.GD-88product-image', 1.5, { css: { scale: 0.9 } }),
        TweenLite.to('.GD-88product-image', 4, { className: '+=trans-GD-88product-image' }),
        TweenLite.fromTo('.GD-88product-image', 1.5, { rotation: 0 }, { css: { rotation: 30 } }),
    ]);
    if ($(window).width() > 1100) {
        new ScrollMagic.Scene({
            triggerElement: '.GD-88-changeBg-container',
            triggerHook: 'onCenter',
            duration: '150%',
            offset: 540,
        })
            .setTween(t2)
            .setPin('.GD-88-changeBg-container')
            .addTo(Gd88controller);
    }
});